/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	// The require scope
/******/ 	var __webpack_require__ = {};
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
/*!**********************************************!*\
  !*** ./src/scripts/collection/collection.js ***!
  \**********************************************/
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
var collection = function collection() {
  return {
    loading: false,
    windowWidth: window.innerWidth,
    query: '',
    urlParams: '',
    mobileFiltersShow: false,
    html: null,
    dropdowns: null,
    openDetailElement: null,
    collectionhandle: null,
    filterForm: null,
    count: null,
    paginateItems: null,
    filterFormMobile: null,
    sort: null,
    collectionData: null,
    html_dom: null,
    activeFiltersCount: null,
    init: function init() {
      this.html = document.querySelector('html');
      this.dropdowns = document.querySelectorAll('.filter-dropdown');
      this.collectionData = JSON.parse(document.querySelector('[data-collection-json]').textContent);
      this.collectionhandle = this.collectionData.hendler;
      this.count = this.collectionData.paginate_count;
      this.paginateItems = this.collectionData.paginate_items;
      this.filterForm = document.querySelector('[data-filter-form]');
      // this.filterFormMobile = document.querySelector('[data-mobile-filter]')
      this.urlParams = new URL(window.location.href);
      this.sortCollection();
      this.calculateProgressBarWidth(this.count, this.paginateItems);
      this.activeFiltersCount = document.querySelector('[data-filters-active]');
    },
    changePrice: function changePrice(rangeMin, priceMin, rangeMax, priceMax, event) {
      priceMin.value = rangeMin;
      priceMax.value = rangeMax;
      this.updateFilter(event);
    },
    sortCollection: function sortCollection() {
      var _this = this;
      var queryString;
      var PageMediaQuery = window.matchMedia('(max-width: 990px)');
      if (PageMediaQuery.matches && this.filterFormMobile != null) {
        queryString = new URLSearchParams(new FormData(this.filterFormMobile)).toString();
      } else {
        queryString = new URLSearchParams(new FormData(this.filterForm)).toString();
      }
      this.sort = document.querySelector("#sort_by").value;
      var url = '/collections/' + this.collectionhandle + '?sort_by=' + this.sort + '&' + queryString;
      fetch(url).then(function (response) {
        return response.text();
      }).then(function (data) {
        var html_div = document.createElement('div');
        html_div.innerHTML = data;
        var html_dom = html_div.querySelector('#ProductGridContainer').innerHTML;
        document.querySelector('#ProductGridContainer').innerHTML = html_dom;

        // update url without refreshing the page
        history.replaceState(null, null, '?sort_by=' + _this.sort + '&' + queryString);
      })["catch"](function (error) {
        return console.error('Error:', error);
      })["finally"](function () {
        return _this.loading = false;
      });
    },
    calculateProgressBarWidth: function calculateProgressBarWidth(count, paginateItems) {
      return count * 100 / parseInt(paginateItems) + '%';
    },
    updateFilter: function updateFilter(event) {
      var _this2 = this;
      this.sort = document.querySelector("#sort_by").value;
      var PageMediaQuery = window.matchMedia('(max-width: 990px)');
      var queryString;
      if (PageMediaQuery.matches && this.filterFormMobile != null) {
        queryString = new URLSearchParams(new FormData(this.filterFormMobile)).toString();
      } else {
        queryString = new URLSearchParams(new FormData(this.filterForm)).toString();
      }
      this.query = queryString;
      fetch('/collections/' + this.collectionhandle + '?' + this.query + '&sort_by=' + this.sort).then(function (response) {
        return response.text();
      }).then(function (data) {
        var html_div = document.createElement('div');
        html_div.innerHTML = data;
        var html_dom = html_div.querySelector('#ProductGridContainer').innerHTML;
        document.querySelector('#ProductGridContainer').innerHTML = html_dom;
        var filter_html = html_div.querySelector('.mobile-filters__container').innerHTML;
        document.querySelector('.mobile-filters__container').innerHTML = filter_html;
        var activeFilters = html_div.querySelector('[data-active-filters-wrap]').innerHTML;
        document.querySelector('[data-active-filters-wrap]').innerHTML = activeFilters;
        var filterDropdownValuesNew = html_div.querySelectorAll('.filter-dropdown__values');
        var filterDropdownValuesCurrent = document.querySelectorAll('.filter-dropdown__values');
        filterDropdownValuesCurrent.forEach(function (element, index) {
          element.innerHTML = filterDropdownValuesNew[index].innerHTML;
        });
        var dataProductDesktopNew = html_div.querySelectorAll('[data-product-desktop]');
        var dataProductDesktopCurrent = document.querySelectorAll('[data-product-desktop]');
        dataProductDesktopCurrent.forEach(function (element, index) {
          element.innerHTML = dataProductDesktopNew[index].innerHTML;
        });
        var activeFiltersCount = html_div.querySelector('[data-filters-active]').innerHTML;
        _this2.activeFiltersCount.innerHTML = activeFiltersCount;

        // update url without refreshing the page
        history.pushState(null, null, '?' + _this2.query + '&sort_by=' + _this2.sort);
      })["catch"](function (error) {
        return console.error('Error:', error);
      })["finally"](function () {
        return _this2.loading = false;
      });
    },
    clearFilter: function clearFilter() {
      this.loading = true;
      var url = '/collections/' + this.collectionhandle;
      this.pushFilter(url);
    },
    pushFilter: function pushFilter(newUrl) {
      var _this3 = this;
      this.loading = true;
      fetch(newUrl).then(function (response) {
        return response.text();
      }).then(function (data) {
        var html_div = document.createElement('div');
        html_div.innerHTML = data;
        var html_dom = html_div.querySelector('#ProductGridContainer').innerHTML;
        document.querySelector('#ProductGridContainer').innerHTML = html_dom;
        var filter_html = html_div.querySelector('.mobile-filters__container').innerHTML;
        document.querySelector('.mobile-filters__container').innerHTML = filter_html;
        var activeFilters = html_div.querySelector('[data-active-filters-wrap]').innerHTML;
        document.querySelector('[data-active-filters-wrap]').innerHTML = activeFilters;
        var filterDropdownValuesNew = html_div.querySelectorAll('.filter-dropdown__values');
        var filterDropdownValuesCurrent = document.querySelectorAll('.filter-dropdown__values');
        filterDropdownValuesCurrent.forEach(function (element, index) {
          element.innerHTML = filterDropdownValuesNew[index].innerHTML;
        });
        var dataProductDesktopNew = html_div.querySelectorAll('[data-product-desktop]');
        var dataProductDesktopCurrent = document.querySelectorAll('[data-product-desktop]');
        dataProductDesktopCurrent.forEach(function (element, index) {
          element.innerHTML = dataProductDesktopNew[index].innerHTML;
        });
        var activeFiltersCount = html_div.querySelector('[data-filters-active]').innerHTML;
        _this3.activeFiltersCount.innerHTML = activeFiltersCount;

        // update url without refreshing the page
        history.pushState(null, null, newUrl);
      })["catch"](function (error) {
        return console.error('Error:', error);
      })["finally"](function () {
        var queryString = new URLSearchParams(new FormData(_this3.filterForm)).toString();
        _this3.query = queryString;
        _this3.loading = false;
      });
    },
    loadMore: function loadMore(NextUrl) {
      var _this4 = this;
      this.loading = true;
      fetch(NextUrl).then(function (response) {
        return response.text();
      }).then(function (data) {
        var html_div = document.createElement('div');
        html_div.innerHTML = data;
        var button = document.querySelector('#product_pagination .button');
        var href = button.getAttribute('href');
        var url = new URL(href, window.location.origin);
        var pageValue = url.searchParams.get('page');
        if (pageValue && parseInt(pageValue) === parseInt(button.getAttribute('data-total-pages'))) {
          document.querySelector('#product_pagination').style.display = 'none';
        }
        var html_dom = html_div.querySelector('#product_grid').innerHTML;
        document.querySelector('#product_grid').innerHTML += html_dom;
        if (html_div.querySelector('#product_pagination')) {
          var pagination_dom = html_div.querySelector('#product_pagination').innerHTML;
          if (document.querySelector('#product_pagination')) {
            document.querySelector('#product_pagination').innerHTML = pagination_dom;
          }
        }
        document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
      })["catch"](function (error) {
        return console.error('Error:', error);
      })["finally"](function () {
        return _this4.loading = false;
      });
    },
    openMobileFilters: function openMobileFilters() {
      this.mobileFiltersShow = true;
      this.html.style.overflow = 'hidden';
    },
    closeMobileFilters: function closeMobileFilters() {
      this.mobileFiltersShow = false;
      this.html.style.overflow = 'visible';
    },
    switchProductGridLayout: function switchProductGridLayout(tirgerButton, productGrid) {
      var allButns = document.querySelectorAll('[data-button-cols]');
      allButns.forEach(function (button) {
        button.classList.remove('active');
      });
      tirgerButton.classList.add('active');
      var gridColsCount = tirgerButton.getAttribute('data-button-cols');
      productGrid.setAttribute('data-grid-cols', gridColsCount);
    }
  };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (collection);
document.addEventListener("alpine:init", function () {
  Alpine.data("collection", collection);
});
/******/ })()
;